import React, { useEffect, useState } from "react";
import { base_url } from "../../../utils/AxiosConfig";
import axios from "axios";
import { FaRegEye } from "react-icons/fa";
import LeavePopup from "../LeavePopup";
import { IoPersonAddSharp } from "react-icons/io5";
import AddLeaveCatPopup from "./AddLeaveCatPopup";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import dayjs from "dayjs";
import { MdSave } from "react-icons/md";
import { Alert, Snackbar } from "@mui/material";

let Leaveschema = Yup.object().shape({
  CmpCode: Yup.string(),
  EmpId: Yup.string(),
  LeaveCategory: Yup.string(),
  NoOfLeaves: Yup.string(),
  // settledNoOfLeaves: Yup.string(),
  settled: Yup.string(),
});
const LeaveAlotment = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [data, setData] = useState();
  const [DataLeave, setDataLeave] = useState();
  const [LeaveEmpId, setLeaveEmpId] = useState(null);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedgrade, setSelectedGrade] = useState(false);
  const [selectedJob, setSelectedJobTitle] = useState(null);
  const [searchdata, setSearchData] = useState();
  const [Division, setDivision] = useState(null);
  const [jobtitle, setJobTitle] = useState(null);
  const [grade, setGrade] = useState(false);
  const [loader, setLoader] = useState(true);
  const [filteredData, setFilteredData] = useState();
  const [EmpId, setEmpId] = useState([]);
  const [filterview, setFilterView] = useState(false);
  const [LeaveData, setLeaveData] = useState();
  const [LeaveCategory, setLeaveCategory] = useState(null);
  const [apiData, setApiData] = useState(null);
  const [addView, setAddView] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [ResetData, setResetData] = useState(false);
  const [alldata, setallData] = useState(false);
  const [resetalldata, setResetallData] = useState(false);
  const [multiSelect, setmultiSelect] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [empIdPopup, setEmpIdPopup] = useState(null);


  const [newStatedata, setnewStatedata] = useState();
  const [employeeIDs, setEmployeeIDs] = useState([]);
  const [key, setKey] = useState([]);
  const [values, setValues] = useState([]);
  const [valueHistory, setValueHistory] = useState();
  const [Open, setOpen] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    msg: "",
    severity: "",
  });

  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = data?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(data?.length / recordsPerPage);
  const numbers = Array.from({ length: npage }, (_, i) => i + 1);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CmpCode: companyCode,
      EmpId: "",
      LeaveCategory: LeaveCategory,
      NoOfLeaves: "",
      // settledNoOfLeaves: "",
      settled: "",
    },
    validationSchema: Leaveschema,
  });

  const LeavePostData = async (formValues, resetForm) => {
    console.log("formValues", formValues);
    const updatedApiData = apiData.map((item) => ({
      ...item,
      LeaveCategory: formValues.LeaveCategory,
      NoOfLeaves: formValues.NoOfLeaves,
      settled: formValues.settledNoOfLeaves || 0,
    }));

    console.log("updatedApiData", updatedApiData);

    setApiData(updatedApiData);

    try {
      const response = await axios.post(
        `${base_url}/api/PersonalInfoLeaveAllotmentReg`,
        updatedApiData,
        {
          headers: {
            "Content-Type": "application/json", // Set the content type to application/json
          },
        },
      );
      if (response.status === 200) {
        // toast.success("Leave Allotted Successfully");
        setSnackbar({
          open: true,
          msg: "Leave Allotted Successfully",
          severity: "success",
        });
        getData();
        ResetDataFunction();
        // resetForm();
      } else {
        // toast.error("Something Went wrong");
        setSnackbar({
          open: true,
          msg: "Something Went wrong",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("PersonalInfoLeaveAllotmentRegErr:", error);
      // toast.error("Failed to allot leave");
      setSnackbar({
        open: true,
        msg: "Failed to allot leave",
        severity: "error",
      });
    }
  };

  const ResetDataFunction = async () => {
    // setApiData(false);
    setSelectedItems([]);
    setSearchData(null);
    setLeaveEmpId(null);
    setEmpId(null);
    // setLeaveCategory(null);
  };

  // useEffect(() => {
  //   if (selectedItems) {
  //     setAddView(true);
  //   } else if (selectedItems === false) {
  //     setAddView(false);
  //   }
  // }, [selectedItems]);

  useEffect(() => {
    if (selectedItems.length > 0) {
      setAddView(true);
    } else {
      setAddView(false);
    }
  }, [selectedItems]);

  useEffect(() => {
    if (values && selectedItems) {
      let newArray = [];

      for (let i = 0; i < selectedItems?.length; i++) {
        newArray.push({
          CmpCode: companyCode,
          EmpID: selectedItems[i] || "",
          LeaveCategory: values?.LeaveCategory || "",
          NoOfLeaves: values?.NoOfLeaves || "",
          // settledNoOfLeaves: values?.settledNoOfLeaves || "",
          settled: values?.settledNoOfLeaves || "",
        });
      }

      console.log("newArray", newArray);

      setApiData(newArray);
    }

    // setValues(false)
  }, [values, selectedItems]);

  useEffect(() => {
    if (ResetData === true) {
      setApiData(false);

      setSearchData(null);
      setLeaveEmpId(null);
      setEmpId(null);
      setLeaveCategory(null);
      // toast.success("Reset Form Data ");
      setSnackbar({
        open: true,
        msg: "Form Data Reset",
        severity: "success",
      });
      setResetData(false);
      setallData(true);
    }
  }, [ResetData]);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`,
        );
        if (response?.data) {
          setData(response.data);
          setallData(false);
        }
      } catch (error) {
        console.error("PersonalInfoListEerror:", error);
      }
    };

    getData();
  }, [alldata]);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`,
        );
        if (response?.data) {
          setData(response.data);
          setallData(false);
        }
      } catch (error) {
        console.error("PersonalInfoListEerror:", error);
      }
    };

    getData();
  }, [alldata, apiData]);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`,
      );
      if (response?.data) {
        setData(response.data);
        setSearchData("");
        setSelectedJobTitle("");
        setSelectedDivision("");
        setSelectedGrade("");
        setResetallData(false);
      }
    };
    if (
      resetalldata === true ||
      (selectedJob === "" && selectedDivision === "" && selectedgrade === "")
    ) {
      getData();
      console.log("Reset All Data");
    }
  }, [resetalldata, selectedDivision, selectedJob, selectedgrade]);

  useEffect(() => {
    const getData = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : "ALL"
        }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade ? selectedgrade : "ALL"
        }/${selectedDivision ? selectedDivision : "ALL"}`,
      );
      if (response?.data) {
        setData(response.data);
      }
    };

    getData();
  }, [selectedDivision, selectedJob, selectedgrade]);

  useEffect(() => {
    if (selectAll === true) {
      setAddView(true);
    } else {
      setAddView(false);
    }
  }, [selectAll]);

  // useEffect(() => {

  //   if (apiData) {
  //     LeavePostData();
  //   }
  // }, [apiData]);

  useEffect(() => {
    const getLeave = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/ALL/-`,
        );
        if (response?.data) {
          setLeaveData(response.data);
        } else {
          console.log("getLeave", "error: No data received");
        }
      } catch (error) {
        console.error("getLeave", "error:", error);
      }
    };

    getLeave();
  }, [apiData]);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`,
      );
      if (response?.data) {
        setData(response.data);
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getSearch = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/FREETEXT/YES/${searchdata ? searchdata : "ALL"
        }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade ? selectedgrade : "ALL"
        }/${selectedDivision ? selectedDivision : "ALL"}`,
      );
      if (response?.data) {
        setData(response.data);
      } else {
        console.log("error");
      }
    };
    if (searchdata) {
      setTimeout(() => {
        getSearch();
      }, 10);
    } else {
      const getData = async () => {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : "ALL"
          }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade ? selectedgrade : "ALL"
          }/${selectedDivision ? selectedDivision : "ALL"}`,
        );
        if (response?.data) {
          setData(response.data);
        }
      };

      getData();
    }
  }, [searchdata]);

  useEffect(() => {
    const getFilteredData = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : "ALL"
        }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade ? selectedgrade : "ALL"
        }/${selectedDivision ? selectedDivision : "ALL"}`,
      );
      if (response?.data) {
        setData(response.data);
      } else {
        console.log("error");
      }
    };
    if (selectedJob) {
      console.log(selectedJob, "selectedJob");
      getFilteredData();
    } else if (
      selectedJob === "" &&
      selectedDivision === "" &&
      selectedgrade === ""
    ) {
      console.log("reset activated");
      setResetallData(true);
    }

    console.log(selectedJob);
  }, [selectedJob]);

  useEffect(() => {
    const getFilteredData = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : "ALL"
        }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade ? selectedgrade : "ALL"
        }/${selectedDivision ? selectedDivision : "ALL"}`,
      );
      if (response?.data) {
        setData(response.data);
      } else {
        console.log("error");
      }
    };
    if (selectedDivision) {
      console.log(selectedDivision, "selectedDivision");
      console.log(typeof selectedDivision, "selectedDivisionType");
      getFilteredData();
    } else if (
      selectedJob === "" &&
      selectedDivision === "" &&
      selectedgrade === ""
    ) {
      console.log("reset activated");
      setResetallData(true);
    }

    console.log(selectedJob);
  }, [selectedDivision]);

  useEffect(() => {
    const getFilteredData = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : "ALL"
        }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade !== "Grade" ? selectedgrade : "ALL"
        }/${selectedDivision ? selectedDivision : "ALL"}`,
      );
      if (response?.data) {
        setData(response.data);
      } else {
        console.log("error");
      }
    };
    if (selectedgrade) {
      console.log(selectedgrade, "selectedgrade");
      getFilteredData();
    } else if (
      selectedJob === "" &&
      selectedDivision === "" &&
      selectedgrade === ""
    ) {
      console.log("reset activated");
      setResetallData(true);
    }

    console.log(selectedgrade);
  }, [selectedgrade]);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/MASTERLIST/${companyCode}/DIVISION/-`,
        );
        if (response?.data) {
          setDivision(response.data);
        } else {
          console.log("DIVISION");
        }
      } catch (error) {
        console.error("DIVISIONEerror:", error);
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/MasterList/${companyCode}/JOBTITLE/-`,
        );
        if (response?.data) {
          setJobTitle(response.data);
        } else {
          console.log("JOBTITLE");
        }
      } catch (error) {
        console.error("JOBTITLEerror:", error);
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`,
        );
        if (response?.data) {
          setGrade(response.data);
        } else {
          console.log("GRADE");
        }
      } catch (error) {
        console.error("GRADEerror:", error);
      }
    };

    getData();
  }, []);

  useEffect(() => {
    if (searchdata && data === null) {
      setLoader(true);
    } else if (searchdata && data) {
      setLoader(false);
    }
    getData();
  }, [searchdata, data]);

  useEffect(() => {
    if (records) {
      setLoader(false);
    }
  }, [records]);

  const getData = async () => {
    // console.log(`${base_url}/api/PersonalInfoLeaveAllotment/${companyCode}/ALL/-`)
    try {
      const response = await axios.get(
        // `${base_url}/api/PersonalInfoLeaveAllotment/${companyCode}/ALL/-`
        `${base_url}/api/PersonalInfoLeaveAllotment/${companyCode}/SINGLE/${LeaveEmpId}`,
        // `${base_url}/api/PersonalInfoLeaveAllotment/${companyCode}/SINGLE/${LeaveEmpId}`
      );
      if (response?.data) {
        setDataLeave(response.data);
      } else {
        console.log("PersonalInfoLeaveAllotmentError");
      }
    } catch (error) {
      console.error("PersonalInfoLeaveAllotmenterror:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    // Use an object to store data for each unique EmpID
    const uniqueData = {};

    DataLeave?.forEach((item) => {
      const { EmpID, ...rest } = item;

      if (!uniqueData[EmpID]) {
        uniqueData[EmpID] = { EmpID, data: [] };
      }

      uniqueData[EmpID].data.push(rest);
    });

    // Convert the object values to an array
    const resultArray = Object.values(uniqueData);

    console.log(resultArray);
    setFilteredData(resultArray);
  }, [DataLeave]);

  useEffect(() => {
    // Use an object to store data for each unique EmpID
    const uniqueData = {};

    DataLeave?.forEach((item) => {
      const { EmpID, ...rest } = item;

      if (!uniqueData[EmpID]) {
        uniqueData[EmpID] = { EmpID, data: [] };
      }

      uniqueData[EmpID].data.push(rest);
    });

    // Convert the object values to an array
    const resultArray = Object.values(uniqueData);

    console.log(resultArray);
    setFilteredData(resultArray);
  }, [apiData, DataLeave]);

  // function checkBoxHandler(event) {
  //   const { value, checked } = event.target;

  //   console.log(value);
  //   if (checked) {
  //     setSelectedItems([...selectedItems, value]);
  //     console.log(selectedItems);
  //   } else {
  //     setSelectedItems((prevData) => {
  //       return prevData.filter((EmpId) => {
  //         return EmpId !== value;
  //       });
  //     });
  //   }
  // }
  function checkBoxHandler(event) {
    const { value, checked } = event.target;

    if (checked) {
      // add selected value
      setSelectedItems([...selectedItems, value]);
    } else {
      // remove unselected value
      setSelectedItems(selectedItems.filter((item) => item !== value));
    }
  }

  function checkAllHandler() {
    if (data.length === selectedItems.length) {
      setSelectedItems([]);
    } else {
      const postIds = data?.map((item) => {
        return item.EmpId;
      });
      setSelectedItems(postIds);
    }
  }

  useEffect(() => {
    const getLeave = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/ALL/-`,
        );
        if (response?.data) {
          setLeaveData(response.data);
        } else {
          console.log("getLeave", "error: No data received");
        }
      } catch (error) {
        console.error("getLeave", "error:", error);
      }
    };
    getLeave();
  }, []);

  console.log("apiData", apiData);
  console.log("values", values);
  console.log("selectedItems", selectedItems);
  console.log("filteredData", filteredData);
  console.log("DataLeave", DataLeave);


  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  };

  return (
    <div>
      <div className="container">
        <div className="flex justify-between items-center mb-4">
          {/* <div className="">
            <h6 className="text-2xl font-bold text-gray-600 flex  justify-start items-center">
              Leave Allotment
            </h6>
          </div> */}
          <div className="flex justify-left items-center">
            <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
            <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
              <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                LEAVE ALLOTMENT
              </span>
            </h6>
          </div>

          <div className="flex items-center justify-between gap-4 ">
            <input
              type="text"
              value={searchdata}
              className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400 w-48"
              placeholder="Search by Name or EmpID..."
              onChange={(e) => setSearchData(e.target.value)}
            />
            <button
              onClick={() => setFilterView(!filterview)}
              className="text-sm flex items-center gap-2 px-3 py-1 bg-orange-500 text-gray-100 rounded-lg border border-gray-300 hover:bg-orange-600 transition duration-200"
            >
              <svg
                className="w-3 h-3 text-gray-100"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L15 13.414V20l-6-3v-3.586L3.293 6.707A1 1 0 013 6V4z"
                />
              </svg>
              Filters
            </button>

            {/* <button
              onClick={() => setAddView(!addView)}
              className="text-sm flex items-center gap-2 px-3 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-700 transition duration-200"
            >
              <IoPersonAddSharp className="text-white w-3 h-3" />
              Add
            </button> */}
            {/* </div>

          <div> */}
            {Open === true ? (
              <>
                <LuPanelRightOpen onClick={() => setOpen(false)} />
              </>
            ) : null}
            {Open === false ? (
              <>
                <LuPanelLeftOpen onClick={() => setOpen(true)} />
              </>
            ) : null}
          </div>
        </div>

        <div className="row">
          <div className="container ">
            {filterview ? (
              <>
                {" "}
                <div className="row  mb-4">
                  <div className="col-3">
                    <input
                      type="text"
                      value={searchdata}
                      className="form-control"
                      placeholder="Search Here"
                      onChange={(e) => setSearchData(e.target.value)}
                    />
                  </div>
                  <div className="col-2">
                    <select
                      class="form-select"
                      onChange={(e) =>
                        setSelectedJobTitle(decodeURI(e.target.value))
                      }
                      value={selectedJob}
                      aria-label="Default select example"
                      placeholder="Select Job Title"
                    >
                      <option
                        value=""
                        selected
                        onClick={() => setSelectedJobTitle(null)}
                      >
                        Job Title
                      </option>
                      {jobtitle
                        ? jobtitle?.map((d, i) => (
                          <>
                            <option
                              value={d.Description}
                              onClick={(e) =>
                                setSelectedJobTitle(e.target.value)
                              }
                            >
                              {d.Description}
                            </option>{" "}
                          </>
                        ))
                        : null}
                    </select>
                  </div>
                  <div className="col-2">
                    <select
                      value={selectedgrade}
                      class="form-select"
                      onChange={(e) => setSelectedGrade(e.target.value)}
                      aria-label="Default select example"
                      placeholder="Select Job Title"
                    >
                      <option
                        value=""
                        selected
                        onClick={() => setSelectedGrade(null)}
                      >
                        Grade
                      </option>
                      {grade
                        ? grade?.map((d, i) => (
                          <>
                            <option
                              value={d?.Description}
                              onClick={(e) =>
                                setSelectedGrade(e.target.value)
                              }
                            >
                              {d?.Description}
                            </option>{" "}
                          </>
                        ))
                        : null}
                    </select>
                  </div>
                  <div className="col-2">
                    <select
                      value={selectedDivision}
                      class="form-select"
                      onChange={(e) =>
                        setSelectedDivision(decodeURI(e.target.value))
                      }
                      aria-label="Default select example"
                      placeholder="Select Job Title"
                    >
                      <option
                        value=""
                        selected
                        onChange={() => setSelectedDivision(null)}
                      >
                        Division
                      </option>
                      {Division
                        ? Division?.map((d, i) => (
                          <>
                            <option
                              value={d.Description}
                            // onClick={(e) => setSelectedDivision(e.target.value)}
                            >
                              {d.Description}
                            </option>{" "}
                          </>
                        ))
                        : null}
                    </select>
                  </div>
                  <div className="col-3">
                    <button
                      className="red-btn"
                      onClick={() => setResetallData(true)}
                    >
                      Reset
                    </button>
                  </div>

                  {/* <div className="col-3">
              <select
                class="form-select"
                onChange={(e) => setSelectedDivision(e.target.value)}
                aria-label="Default select example"
              >
                  <option value={null} selected onClick={() => setResetallData(true)}>
                       Division
                      </option>
                {Division
                  ? Division?.map((d, i) => (
                      <>
                        <option
                          value={d?.Description}
                          onChange={(e) => setSelectedDivision(e.target.value)}
                        >
                          {d?.Description}
                        </option>{" "}
                      </>
                    ))
                  : null}
              </select>
            </div> */}
                </div>
              </>
            ) : null}
            {addView ? (
              <>
                {" "}
                {/* <form
                  action=""
                  onSubmit={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                    LeavePostData(formik.values, formik.resetForm);
                  }}
                >
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <select
                        onChange={formik.handleChange("LeaveCategory")}
                        onBlur={formik.handleBlur("LeaveCategory")}
                        value={formik.values.LeaveCategory}
                        class="form-select"
                        placeholder="Leave Category"
                      >
                        <option value="">Leave Category </option>
                        {LeaveData
                          ? LeaveData?.map((d, i) => (
                              <>
                                <option
                                  value={LeaveData[i]?.name}
                                  onClick={(e) =>
                                    setLeaveCategory(e.target.value)
                                  }
                                >
                                  {LeaveData[i]?.name}
                                </option>{" "}
                              </>
                            ))
                          : null}
                      </select>
                    </div>
                    <div className="w-[200px] ">
                      <input
                        type="text"
                        className="form-control "
                        placeholder="Input Leave No Here.."
                        name="NoOfLeaves"
                        onChange={formik.handleChange("NoOfLeaves")}
                        onBlur={formik.handleBlur("NoOfLeaves")}
                        value={formik.values.NoOfLeaves}
                      />
                    </div>
                    <div className="w-[250px] ">
                      <input
                        type="text"
                        className="form-control "
                        placeholder="Input Settled Leaves No Here.."
                        name="settledNoOfLeaves"
                        onChange={formik.handleChange("settledNoOfLeaves")}
                        onBlur={formik.handleBlur("settledNoOfLeaves")}
                        value={formik.values.settledNoOfLeaves}
                      />
                    </div>
                    <div className="w-[160px]">
                      <button
                        type="submit"
                        className="w-full text-sm flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white font-medium px-3 py-2 rounded-lg shadow-md transition-all duration-200 hover:scale-105 active:scale-95"
                      >
                        <MdSave className="text-sm" />
                        Save
                      </button>
                    </div>
                  </div>
                </form> */}
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                    LeavePostData(formik.values, formik.resetForm);
                  }}
                >
                  <div className="row mb-2 items-end gap-2">
                    {/* Leave Category */}
                    <div className="col-md-3">
                      <label className="form-label text-xs text-secondary mb-1">
                        Leave Category
                      </label>

                      <select
                        onChange={formik.handleChange("LeaveCategory")}
                        onBlur={formik.handleBlur("LeaveCategory")}
                        value={formik.values.LeaveCategory}
                        className="form-select"
                      >
                        <option value="">Select Leave Category</option>

                        {LeaveData?.map((d, i) => (
                          <option
                            key={i}
                            value={d?.name}
                            onClick={(e) => setLeaveCategory(e.target.value)}
                          >
                            {d?.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* No Of Leaves */}
                    <div className="w-[200px]">
                      <label className="form-label text-xs text-secondary mb-1">
                        No Of Leaves
                      </label>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Input Leave No Here.."
                        name="NoOfLeaves"
                        onChange={formik.handleChange("NoOfLeaves")}
                        onBlur={formik.handleBlur("NoOfLeaves")}
                        value={formik.values.NoOfLeaves}
                      />
                    </div>

                    {/* Settled Leaves */}
                    <div className="w-[250px]">
                      <label className="form-label text-xs text-secondary mb-1">
                        Settled Leaves
                      </label>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Input Settled Leaves No Here.."
                        name="settledNoOfLeaves"
                        onChange={formik.handleChange("settledNoOfLeaves")}
                        onBlur={formik.handleBlur("settledNoOfLeaves")}
                        value={formik.values.settledNoOfLeaves}
                      />
                    </div>

                    {/* Save Button */}
                    <div className="w-[160px]">
                      <button
                        type="submit"
                        disabled={
                          !formik.values.LeaveCategory ||
                          !formik.values.NoOfLeaves
                        }
                        className={`w-full text-xs flex items-center justify-center gap-2 
        font-medium px-3 py-2 rounded-lg shadow-md transition-all duration-200
        ${!formik.values.LeaveCategory || !formik.values.NoOfLeaves
                            ? "bg-gray-400 cursor-not-allowed text-white"
                            : "bg-green-600 hover:bg-green-700 text-white hover:scale-105 active:scale-95"
                          }`}
                      >
                        <MdSave className="text-sm" />
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </>
            ) : null}

            {data ? (
              <>
                {" "}
                {/* <div className={Open ? "table scroll list-table mt-2 h-auto" : "table scroll list-table mt-2 h-auto"} style={{ maxHeight: "450px" }}> */}
                {/* <div className="bg-white"> */}
                <div className="overflow-scroll scrollbar-none">
                  {/* <table className="table text-xs"> */}
                  <table className="shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs mb-2">
                    <thead>
                      <tr className="bg-[#2663EB] text-white">
                        <th className="px-2 py-1 border-none font-normal">
                          Sl No
                        </th>
                        <th className="px-2 py-1 border-none text-center font-normal">
                          {" "}
                          <input
                            class="form-check-input"
                            type="checkbox"
                            onClick={checkAllHandler}
                            checked={
                              data.length === selectedItems?.length
                                ? true
                                : false
                            }
                          />
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          EmpID
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          Name
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          Job_Title
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          Division
                        </th>
                        <th className="px-2 py-1 border-none font-normal">
                          Grade
                        </th>
                        {Open ? (
                          <>
                            <th className="px-2 py-1 border-none font-normal">
                              Bank Account
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Bank Name
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Agent Id
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Current Address
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Home Address
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Home Airport
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Work Mobile
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Work Phone
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Personal Phone
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Personal Email
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Passport Number
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Passport Issue Date
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Passport Expiry Date
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Passport Place of Issue
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Passport Country of Issue
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Emirates id
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Expiry Date
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Visa No
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Visa Expiry Date
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Insurance Number
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Insurance Expiry Date
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Driving license No
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Driving license Expiry Date
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Basic Pay
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Allowances_OT
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Allownaces_NOT
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              NormalHRS
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              HourlyWage
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              OTRate
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              SplOtRate
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Active
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Memos
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Notes
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Salary Ac
                            </th>
                            <th className="px-2 py-1 border-none font-normal">
                              Advance Ac
                            </th>
                          </>
                        ) : null}
                        <th className="px-2 py-1 border-none font-normal text-center">
                          Leave Details
                        </th>
                        {/* <td>Actions</td> */}
                      </tr>
                    </thead>
                    <tbody>
                      {records
                        ? records?.map((d, i) => (
                          <tr key={i} className="">
                            <td className="px-2 py-1 border">{i + 1}</td>
                            <td className="px-2 py-1 text-center border">
                              {" "}
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value={d?.EmpId}
                                x
                                onChange={checkBoxHandler}
                                // onClick={() => setEmpId(d?.EmpId)}
                                // checked={selectAll === true ? true : null}
                                checked={selectedItems.includes(d?.EmpId)}
                              />
                            </td>
                            <td className="px-2 py-1 border">{d?.EmpId}</td>
                            <td className="px-2 py-1 border">{d?.Name}</td>
                            <td className="px-2 py-1 border">
                              {d?.JobTitle}
                            </td>
                            <td className="px-2 py-1 border">
                              {d?.Division}
                            </td>
                            <td className="px-2 py-1 border">{d?.Grade}</td>
                            {Open ? (
                              <>
                                <td className="px-2 py-1 border">
                                  {d?.BankAccountNo}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.BankName}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.AgentID}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.CurrentAddress}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.HomeAddress}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.HomeAirport}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.WorkMobile}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.WorkPhone}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.PersonalPhone}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.PersonalEmail}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.PassportNo}
                                </td>
                                <td className="px-2 py-1 border">
                                  {dayjs(d?.PassportIssueDate).format(
                                    "DD-MMM-YYYY ",
                                  )}
                                </td>
                                <td className="px-2 py-1 border">
                                  {dayjs(d?.PassportExpiryDate).format(
                                    "DD-MMM-YYYY ",
                                  )}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.PassportPlaceofIssue}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.PassportCountryofIssue}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.EmiratesId}
                                </td>
                                <td className="px-2 py-1 border">
                                  {dayjs(d?.EmiratesIdExpiryDate).format(
                                    "DD-MMM-YYYY ",
                                  )}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.VisaNo}
                                </td>
                                <td className="px-2 py-1 border">
                                  {dayjs(d?.VisaExpiryDate).format(
                                    "DD-MMM-YYYY ",
                                  )}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.InsuranceNo}
                                </td>
                                <td className="px-2 py-1 border">
                                  {dayjs(d?.InsuranceExpiryDate).format(
                                    "DD-MMM-YYYY ",
                                  )}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.DrivingLicenceNo}
                                </td>
                                <td className="px-2 py-1 border">
                                  {dayjs(d?.DrivingLicenceExpiryDate).format(
                                    "DD-MMM-YYYY ",
                                  )}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.BasicPay}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.Allowances_OT}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.Allowances_NOT}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.NormalHrs}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.HourlyWage}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.OTrate}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.SplOtRate}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.Active}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.Memos}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.Notes}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.SalaryA}
                                </td>
                                <td className="px-2 py-1 border">
                                  {d?.AdvanceAc}
                                </td>
                              </>
                            ) : null}

                            <td className="px-2 py-1 border text-center space-x-2">
                              <button
                                // className="dash-btn"
                                className="font-semibold bg-green-500 text-white px-2 py-1 rounded-md"
                                // data-bs-toggle="modal"
                                // data-bs-target="#exampleModal"
                                onClick={() => setLeaveEmpId(d?.EmpId)}
                              >
                                {/* <FaRegEye /> */}
                                {/* &nbsp;View */}
                                View
                              </button>
                              {LeaveEmpId === d?.EmpId && (
                                <LeavePopup
                                  // apiData={apiData}
                                  LeaveEmpId={LeaveEmpId}
                                  filteredData={filteredData}
                                  setLeaveEmpId={setLeaveEmpId}
                                />
                              )}
                              {/* <button className="font-semibold bg-blue-500 text-white px-2 py-1 rounded-md" onClick={() => setEmpIdPopup(d?.EmpId)}>Add</button>
                              {empIdPopup === d?.EmpId && (
                                <AddLeaveCatPopup EmpIdPopUp={empIdPopup} setEmpIdPopup={setEmpIdPopup} />
                              )} */}
                            </td>
                          </tr>
                        ))
                        : null}
                    </tbody>
                  </table>
                </div>
              </>
            ) : null}

            {records ? (
              <>
                <div className="pagination-div">
                  <div className="text-end">
                    <nav aria-label="Page navigation example">
                      <ul class="pagination">
                        <li class="page-item">
                          {currentPage !== 1 ? (
                            <button
                              class="page-link"
                              href="#"
                              onClick={prePage}
                            >
                              Previous
                            </button>
                          ) : (
                            ""
                          )}
                        </li>
                        {numbers.map((n, i) => (
                          <li
                            className={`page-item ${currentPage === n ? "active" : ""
                              }`}
                            key={i}
                          >
                            <button
                              className="page-link"
                              onClick={() => changeCPage(n)}
                              href="#"
                            >
                              {n}
                            </button>
                          </li>
                        ))}

                        <li class="page-item">
                          {currentPage !== numbers[numbers.length - 1] ? (
                            <button
                              class="page-link"
                              href="#"
                              onClick={nextPage}
                            >
                              Next
                            </button>
                          ) : null}
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div className="table-nodata-img mtd">
        {loader ? (
          <>
            {" "}
            <div className="table-nodata-img">
              <div className="center">
                <p className="text-center pt-5">
                  Please Wait Loading Data... &nbsp;
                  <div className="flex justify-center items-center py-8">
              <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              <span className="ml-3 text-gray-600 text-sm">Loading data...</span>
            </div>
                </p>
              </div>
            </div>
          </>
        ) : null}
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.msg}
        </Alert>
      </Snackbar>
    </div>
  );

  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }
};

export default LeaveAlotment;
